import squareRoom from '@assets/modal/modal-wall-builder/Cuadrada.jpg'
import lRightShapedRoom from '@assets/modal/modal-wall-builder/L Der.jpg'
import lLeftShapedRoom from '@assets/modal/modal-wall-builder/L Izq.jpg'
import lShapedRoom from '@assets/modal/modal-wall-builder/L.jpg'
import straightRoom from '@assets/modal/modal-wall-builder/Recta.jpg'
import { useAppStore } from '@store'

export function RoomImage() {
  const selectedRoom = useAppStore.use.selectedRoom()

  function getRoomImage() {
    let image

    switch (selectedRoom) {
      case 'CUADRADA':
        image = squareRoom
        break
      case 'RECTA':
        image = straightRoom
        break
      case 'ENL':
        image = lShapedRoom
        break
      case 'LIZQUIERDA':
        image = lLeftShapedRoom
        break
      case 'LDERECHA':
        image = lRightShapedRoom
        break
      default:
        break
    }

    return (
      <img
        className='mt-[40%] h-56 px-4'
        src={image}
      />
    )
  }

  return (
    <section>
      {/* display: flex; justify-content: space-between; background-color: #3b476d; color: white;
      padding: 0.578em 1.5em; font-weight: 500; font-size: 13px; border-top-left-radius: 8px;
      margin-top: -0.5px; margin-left: -0.5px; */}
      <div className='border-tl-[8px] text-md sticky top-0 ml-[-0.5px] mt-[-0.5px] flex justify-between rounded-tl-[8px] bg-C/Color3 p-[0.54em_1.5em] font-medium text-C/Color1'>
        {'Paredes'}
      </div>
      <div className='sticky top-0 flex h-[745px] justify-center border-r-2 border-C/Color3'>
        {getRoomImage()}
      </div>
    </section>
  )
}
